import React, { useState } from 'react';
import { Tag, Tooltip } from 'antd';
import {
  FileTextOutlined,
  BarChartOutlined,
  DatabaseOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';
import SourceDetailModal from './SourceDetailModal';
import styles from '../../styles/chatV2.module.css';

const InlineSourceChip = ({ source, index }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const getSourceIcon = () => {
    switch (source.sourceType) {
      case 'ExecutiveBriefing':
        return <FilePdfOutlined />;
      case 'AISummary':
        return <FileTextOutlined />;
      case 'ModuleDigest':
        return <BarChartOutlined />;
      case 'RawDataset':
        return <DatabaseOutlined />;
      default:
        return <FileTextOutlined />;
    }
  };

  const getSourceColor = () => {
    switch (source.sourceType) {
      case 'ExecutiveBriefing':
        return 'purple';
      case 'AISummary':
        return 'blue';
      case 'ModuleDigest':
        return 'green';
      case 'RawDataset':
        return 'orange';
      default:
        return 'default';
    }
  };

  const getSourceLabel = () => {
    if (source.sourceType === 'RawDataset') {
      if (source.queryType === 'AGGREGATION') {
        return `[${index}] ${source.title}`;
      }
      return `[${index}] ${source.tableName} Data`;
    }
    return `[${index}] ${source.title || source.reportName || 'Source'}`;
  };

  return (
    <>
      <Tooltip
        title={source.excerpt || 'Click to view details'}
        placement="top"
      >
        <Tag
          icon={getSourceIcon()}
          color={getSourceColor()}
          className={styles.sourceChip}
          onClick={() => setModalVisible(true)}
        >
          {getSourceLabel()}
        </Tag>
      </Tooltip>

      {/* Expanded Source Detail Modal */}
      <SourceDetailModal
        visible={modalVisible}
        source={source}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
};

export default InlineSourceChip;
